import { Grid } from "@mui/material";
import ByzCard from "src/components/core-components/ByzCard";
import ByzTitleBox from "src/components/core-components/ByzTitleBox";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMcParameterDetailRadio from "src/components/shared-components/ByzMcParameterDetailRadio";

interface NewBornScaleNipsProps {
  t: (key: string) => string;
  cardData: any;
  selectedMCPs: Record<string, any>;
  handleMCPChange: (key: string, value: any) => void;
  getMCPParameterDetails: (id: number) => any;
  mcpCacheLoaded: boolean;
}

const NewBornScaleNips: React.FC<NewBornScaleNipsProps> = ({
  t,
  cardData,
  selectedMCPs,
  handleMCPChange,
  getMCPParameterDetails,
  mcpCacheLoaded,
}) => {
  return (
    <ByzCard sx={{ mt: 3, mb: 5 }}>
      <ByzTitleBox title={t("pain-assessment-scale.new-born-scale.title")} />

      <ByzCard sx={{ padding: 0, ml: 1, mb: 1 }}>
        {/* 1. Grup - Yüz İfadesi & Ağlama */}
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.new-born-scale.face-expression")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.NIPS_FACE_EXPRESSION.mcpId}
              value={selectedMCPs.NIPS_FACE_EXPRESSION}
              handleChange={(val) => val && handleMCPChange("NIPS_FACE_EXPRESSION", val)}
              cachedData={getMCPParameterDetails(cardData.mcpConfig.NIPS_FACE_EXPRESSION.mcpId)}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.new-born-scale.nips-cry")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.NIPS_CRY.mcpId}
              value={selectedMCPs.NIPS_CRY}
              handleChange={(val) => val && handleMCPChange("NIPS_CRY", val)}
              cachedData={getMCPParameterDetails(cardData.mcpConfig.NIPS_CRY.mcpId)}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>
        </Grid>

        {/* 2. Grup - Solunum Şekli & Kollar */}
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.new-born-scale.nips-respiratory-form")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.NIPS_RESPIRATORY_FORM.mcpId}
              value={selectedMCPs.NIPS_RESPIRATORY_FORM}
              handleChange={(val) => val && handleMCPChange("NIPS_RESPIRATORY_FORM", val)}
              cachedData={getMCPParameterDetails(cardData.mcpConfig.NIPS_RESPIRATORY_FORM.mcpId)}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.new-born-scale.nips-arms")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.NIPS_ARMS.mcpId}
              value={selectedMCPs.NIPS_ARMS}
              handleChange={(val) => val && handleMCPChange("NIPS_ARMS", val)}
              cachedData={getMCPParameterDetails(cardData.mcpConfig.NIPS_ARMS.mcpId)}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>
        </Grid>

        {/* 3. Grup - Bacaklar & Uyanıklık */}
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.new-born-scale.nips-legs")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.NIPS_LEGS.mcpId}
              value={selectedMCPs.NIPS_LEGS}
              handleChange={(val) => val && handleMCPChange("NIPS_LEGS", val)}
              cachedData={getMCPParameterDetails(cardData.mcpConfig.NIPS_LEGS.mcpId)}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.new-born-scale.nips-wakefulness")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.NIPS_WAKEFULLNESS.mcpId}
              value={selectedMCPs.NIPS_WAKEFULLNESS}
              handleChange={(val) => val && handleMCPChange("NIPS_WAKEFULLNESS", val)}
              cachedData={getMCPParameterDetails(cardData.mcpConfig.NIPS_WAKEFULLNESS.mcpId)}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>
        </Grid>
      </ByzCard>

      {/* Skor Bilgisi */}
      <ByzCard sx={{ padding: 0, ml: 1, mt: 0 }}>
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={6}>
            <ByzMuiTypography fontWeight={400}>
              {"0 - Ağrı Yok , 1-2 Hafif Ağrı , 3-4 Orta Şiddetli Ağrı , > 4 Şiddetli Ağrı"}
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <ByzMuiTypography fontWeight={400}>Skor : 1</ByzMuiTypography>
          </Grid>
        </Grid>
      </ByzCard>
    </ByzCard>
  );
};

export default NewBornScaleNips;
